<template>
  <lu-hbox lu-vcenter style='margin-bottom: 10px;'>
    <lu-hbox lu-vcenter lu-flex lu-click class='pad-in-5 pageTitleLabel' @click='toggleClose'>
      <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' :class="isExpanded ? 'isActive' : '' "/>
      <lu-item :class='resizeFont("title2", "divTitle")'>{{ title }}</lu-item>
    </lu-hbox>

    <slot name='extraArea'/>

    <lu-item v-if='hasClose' lu-click class='headerIcon el-icon-close error' style='margin-right:10px;' @click.stop='togglePageTitle'></lu-item>
  </lu-hbox>
</template>

<script>
import { LuHbox, LuItem } from 'lusis-ui'
import FontIcon from '@/components/FontIcon'
import utilsMixin from '@/mixins/utils'

export default {
  name: 'PageTitle',
  mixins: [ utilsMixin ],
  components: { LuHbox, LuItem, FontIcon },
  props: [ 'title', 'expanded', 'hasClose' ],
  data: function () {
    return {
      isExpanded: true
    }
  },
  watch: {
    expanded: {
      handler: function (v) {
        if (v !== undefined) this.isExpanded = v
      },
      immediate: true
    }
  },
  methods: {
    togglePageTitle () {
      this.$emit('togglePageTitle')
    },
    toggleClose () {
      this.$emit('toggleClose')
      this.isExpanded = !this.isExpanded
      this.$emit(this.isExpanded ? 'expanded' : 'collapsed')
    }
  }
}

</script>